import axios from "axios";

const ReleaseApi = {
  getVersion: () => axios.get(`${process.env.NEXT_PUBLIC_HOST}/api/version`),
};

export default ReleaseApi;
